import React, { Component } from 'react';
import { BrowserRouter as Router, Route, Link, Redirect, NavLink, HashRouter } from "react-router-dom";
import Header from './../../Header';
import HeaderMob from './../../HeaderMob';
import $ from 'jquery';
import DatePicker from 'react-datepicker';
import moment from 'moment';
import 'react-datepicker/dist/react-datepicker.css';
import CryptoJS from 'crypto-js';
import config from 'react-global-configuration';
import AutoComplete from 'material-ui/AutoComplete';
import getMuiTheme from 'material-ui/styles/getMuiTheme';
import MuiThemeProvider from 'material-ui/styles/MuiThemeProvider';
import MaintenanceWindow from '../MaintenanceWindow';
const dataSourceConfig = {
        text: 'title',
                value: 'id',
                };
class UpdateEr extends Component {
    constructor() {
        super();
        var has_local_data = localStorage.getItem('encdata') ? 1 : 0;
        var localdata = has_local_data ? this.decrypt(localStorage.getItem('encdata'), 0) : '';
        this.state = {
            add_sub_effort: [],
            effort: [],
            search: [],
            er: '',
            apiUrl: this.decryptconfigdata('apiUrl'),
            owners: [],
            product_line: [],
            category: [],
            owner: '',
            assign_to: [],
			assign_to_new:[],
			assign_to_title:[],
			assign_to_auto:'',
            type: [],
            team: [],
            er_attachment: [],
            priority: [],
            status: [],
            title: '',
            server: [],
            description: '',
            support_level: '',
            supportLevels: [],
            start_date: '',
            startdate: '',
            end_date: '',
            enddate: '',
            go_live_date: '',
            go_live_date_old:'',
            golivedate: '',
            browser: [],
            microservice: [],
            os_version: [],
            browser_version: '',
            ticket: '',
            files: '',
            attachments: '',
            attachment_url: '',
            created_date: '',
            workflow: [],
            config: [],
            last_updated_date: '',
            account_managerinse: '',
            project: '',
            userId: has_local_data ? localdata.user_id : '',
            userName: has_local_data ? localdata.user_name : '',
            userAuthKey: has_local_data ? localdata.user_key : '',
            fields: {},
            errors: {},
            error_message: '',
            checkBox: true,
            setdefault: '',
            setFeature: '',
            maintenanceWindow: 0
        }
        this.updateEr = this.updateEr.bind(this);
        this.onChange = this.onChange.bind(this);
        this.startdateChange = this.startdateChange.bind(this);
        this.enddateChange = this.enddateChange.bind(this);
        this.golivedateChange = this.golivedateChange.bind(this);
        this.getSearchERNumber = this.getSearchERNumber.bind(this);
        this.maintenance = this.maintenance.bind(this);
    }
    decryptconfigdata(configkey) {
        var key = CryptoJS.enc.Hex.parse(config.get('enc_key'));
        var iv = CryptoJS.enc.Hex.parse(config.get('enc_iv'));
        var bytes = CryptoJS.AES.decrypt(config.get(configkey), key, {
            iv
        });
        var plaintext = bytes.toString(CryptoJS.enc.Utf8);
        return plaintext;
    }

    decrypt(findresponse, flg) {
        var key = CryptoJS.enc.Hex.parse(config.get('enc_key'));
        var iv = CryptoJS.enc.Hex.parse(config.get('enc_iv'));
        var res = flg ? findresponse.encdata : findresponse;
        var bytes = CryptoJS.AES.decrypt(res, key, {
            iv
        });
        var plaintext = bytes.toString(CryptoJS.enc.Utf8);
        return JSON.parse(plaintext);
    }

    rawjsonparse(findresponse, flg) {
        return findresponse;
    }

	getAssignTo(searchText = '') {
        fetch(this.state.apiUrl + '/ErRest/getAssignTo/userAuthKey/' + this.state.userAuthKey + '/searchText/' + searchText, {
        method: 'POST',
                dataType: 'json',
                body: JSON.stringify(this.state),
        })
                .then((Response) => Response.json())
                .then((findresponse) => {
                findresponse = this.rawjsonparse(findresponse, 1);
                        if (findresponse.code == 200) {
                this.setState({
                search: findresponse.assign_to,
                errorText: ''
                })
                } else {
                this.setState({ errorText: findresponse.msg })
                }

                })
        }

    handleUpdateInput = (searchText) => {
		if(typeof searchText !== "string"){
			//check autocomplete is blank or having value?if not having value make it black
			if(this.state.assign_to_auto){
				searchText= this.state.assign_to_auto;//default value assign here
			}else{ 
				searchText=this.state.assign_to_title;
			}
		}
        this.setState({
            searchText: searchText,
        });
        //this.getERNumber(searchText);
		this.getAssignTo(searchText);
    };

	onNewRequest(chosenRequest, index) {
		this.setState({
			assign_to_new: chosenRequest.id,
			assign_to_title: chosenRequest.title
		})
		this.state.assign_to_auto ="";
	}
	caseInsensitiveFilters = function (searchText, key) {
		  return key.toString().toLowerCase().indexOf(searchText.toString().toLowerCase()) !== -1;
		};

    handleNewRequest = (searchText) => {
        this.getSearchERNumber();
    };

    enterKeyPress(event) {
        if (event.key == 'Enter') {
        }
    }

    getERNumber(searchText = '') {
        fetch(this.state.apiUrl + '/ErRest/getERNumber/userAuthKey/' + this.state.userAuthKey + '/searchText/' + searchText, {
            method: 'POST',
            dataType: 'json',
            body: JSON.stringify(this.state),
        })
            .then((Response) => Response.json())
            .then((findresponse) => {
                findresponse = this.rawjsonparse(findresponse, 1);
                if (findresponse.code == 200) {
                    this.setState({
                        search: findresponse.ers,
                        errorText: ''
                    })
                } else {
                    this.setState({ errorText: findresponse.msg })
                }
            })
    }
    getSearchERNumber() {
        fetch(this.state.apiUrl + '/ErRest/getSearchERNumber/userAuthKey/' + this.state.userAuthKey + '/search/' + this.state.searchText, {
            method: 'POST',
            dataType: 'json',
            body: JSON.stringify(this.state),
        })
            .then((Response) => Response.json())
            .then((findresponse) => {
                findresponse = this.rawjsonparse(findresponse, 1);
                if (findresponse.code == 200) {
                    this.setState({
                        ers: findresponse.ers,
                        item_count: findresponse.item_count,
                    })
                    if (this.state.item_count > 0) {
                        window.location.href = '/viewER/' + findresponse.er_id;
                    }
                }
                else {
                    alert("No result found");
                }
            })
    }

    focousOutStartDate(value) {
        if (!value) {
            this.setState({ startdate: '' });
            this.setState({ start_date: '' });
        }
    }

    startdateChange(event) {
        this.setState({ startdate: event, start_date: moment(event).format("YYYY-MM-DD") }, function () { });
    }
    enddateChange(event) {
        this.setState({ enddate: event, end_date: moment(event).format("YYYY-MM-DD") }, function () { });
    }

    focousOutEndDate(value) {
        if (!value) {
            this.setState({ enddate: '' });
            this.setState({ end_date: '' });
        }
    }

    golivedateChange(event) {
        this.setState({ golivedate: event, go_live_date: moment(event).format("YYYY-MM-DD") }, function () { });
    }

    focousOutGoLiveDate(value) {
        if (!value) {
            this.setState({ golivedate: '' });
            this.setState({ go_live_date: '' });
        }
    }

    handleValidation() {
        let fields = this.state.er;
        let errors = {};
        let formIsValid = true;
        if (!fields["title"]) {
            formIsValid = false;
            errors["title"] = "This field is required.";
        }
        if (!fields["description"] && this.state.er.category != 13) {
            formIsValid = false;
            errors["description"] = "This field is required.";
        }
        if (!fields["category"]) {
            formIsValid = false;
            errors["category"] = "This field is required.";
        }
        if (!fields["priority"]) {
            formIsValid = false;
            errors["priority"] = "This field is required.";
        }
        if (!fields["product_line"] && this.state.er.category != 13) {
            formIsValid = false;
            errors["product_line"] = "This field is required.";
        }
        if (this.state.assign_to_new == "") {
            formIsValid = false;
            errors["assign_to_new"] = "This field is required.";
        }
        if (!fields["user_id"]) {
            formIsValid = false;
            errors["user_id"] = "This field is required.";
        }
        //Er 66478 Effort mandatory
        if (!fields["effort"]) {
            formIsValid = false;
            errors["effort"] = "This field is required.";
        }
        this.setState({ errors: errors });
        return formIsValid;
    }

    updateEr() {
        if (this.handleValidation()) {
            console.log("Data Has been submitted");
        } else {
            console.log("This Fields Are required.")
            return false;
        }
        let img = document.getElementById('attachments').files.length;
        const fd = new FormData;
        if (img > 0) {
            for (var x = 0; x < img; x++) {
                fd.append("image[]", document.getElementById('attachments').files[x]);
            }
        }

        document.getElementById("add_request").disabled = true;
        fd.append('ticket_inputs', JSON.stringify(this.state));
        fetch(this.state.apiUrl + '/ErRest/UpdateEr/id/' + this.props.match.params.erId + '/userId/' + this.state.userId + '/userAuthKey/' + this.state.userAuthKey, {
            method: 'POST',
            dataType: 'json',
            body: fd,
        })
            .then((Response) => Response.json())
            .then((findresponse) => {
                findresponse = this.rawjsonparse(findresponse, 1);
                document.getElementById("add_request").innerHTML = "Submit";
                if (findresponse.code == 200) {
                    this.setState({ message: findresponse.msg }, function () {
                        window.location.href = '/viewER/' + this.props.match.params.erId;
                    });
                } else {

                    this.setState({ message: findresponse.msg })
                }
            })
    }

    getErDetails() {
        $(document).ready(function () {
            $('.loader-new').removeClass('hidden');
            $('.intranet_body').addClass('hidden');
        });

        fetch(this.state.apiUrl + '/ErRest/EditEr/id/' + this.props.match.params.erId + '/userId/' + this.state.userId + '/userAuthKey/' + this.state.userAuthKey)
            .then((Response) => Response.json())
            .then((responseJson) => {
                responseJson = this.rawjsonparse(responseJson, 1);
                $(document).ready(function () {
                    $('.loader-new').addClass('hidden');
                    $('.intranet_body').removeClass('hidden');
                });
                this.setState({
                    er: responseJson.er,
                    er_attachment: responseJson.er_attachment,
                    workflow: responseJson.workflow,
                    config: responseJson.config,
                    owners: responseJson.owner,
                    team: responseJson.team,
                    product_line: responseJson.product_line,
                    category: responseJson.category,
                    type: responseJson.type,
                    priority: responseJson.priority,
                    status: responseJson.status,
                    server: responseJson.server,
                    browser: responseJson.browser,
                    os_version: responseJson.os_version,
                    supportLevels: responseJson.supportLevels,
                    microservice: responseJson.microservice,
                    end_date: responseJson.er.end_date,
                    go_live_date: responseJson.er.go_live_date,
                    go_live_date_old: responseJson.er.go_live_date,
                    effort: responseJson.effort,
                    add_sub_effort: responseJson.add_sub_effort,
                    actual_pod: responseJson.er.product_line,
					assign_to_new:responseJson.er.assign_to,
					assign_to_auto: responseJson.er.assign_to_auto
                })
                this.setState({ searchText: this.state.assign_to_auto });
                if (this.state.er.feature_type == 3) {
                    this.setState({ platform_feature_checked: true, setFeature: 3 })
                }
                else {
                    this.setState({ platform_feature_checked: false })
                }
                if (this.state.er.feature_type == 2) {
                    this.setState({ native_feature_checked: true, setFeature: 2 })
                } else {
                    this.setState({ native_feature_checked: false })
                }
                if (this.state.er.feature_type == 1) {
                    this.setState({ major_feature_checked: true, setFeature: 1 })
                }
                else {
                    this.setState({ major_feature_checked: false })
                }
                if (this.state.er.created_date) {
                    let x = Date.parse(this.state.er.created_date);
                    this.setState({ createddate: moment(x) })
                }
                if (this.state.er.start_date) {
                    let x = Date.parse(this.state.er.start_date);
                    this.setState({ startdate: moment(x) })
                }
                if (this.state.er.end_date) {
                    let x = Date.parse(this.state.er.end_date);
                    this.setState({ enddate: moment(x) })
                }
                if (this.state.er.go_live_date) {
                    let x = Date.parse(this.state.er.go_live_date);
                    this.setState({ golivedate: moment(x) })
                }
            })
    }

    onChange(propertyName, event) {
        if (event.target.name == 'product_line') {
            var cbarray = document.getElementsByClassName('feature_type');
            for (var i = 0; i < cbarray.length; i++) {
                if (this.state.actual_pod == event.target.value) {
                    cbarray[i].checked = true;
                }
                else {
                    cbarray[i].checked = false;
                }
            }
        }
        const er = this.state.er;
        er[propertyName] = event.target.value;
        this.setState({ er: er });
    }
    onFeatureChange(obj) {
        var featureType = "";
        let checkedElements = $(".feature_type:checked");
        if (parseInt(checkedElements.length) > 0) {
            let element = document.querySelector(obj);
            let status = $(element).is(":checked");
            var featureType = $(element).val();
            if (status === true) {
                $(".feature_type").prop("checked", false);
                $(element).prop("checked", true);
            } else {
                $(".feature_type").prop("checked", false);
            }
        }
        return this.setState({ setFeature: featureType });
    }
    showImage(s3url) {
        window.open(s3url);
    }
    delteimage(id, er_id) {
        if (window.confirm('Are you sure to delete?')) {
            fetch(this.state.apiUrl + '/ErRest/deleteErImage/id/' + id + '/er_id/' + er_id + '/userAuthKey/' + this.state.userAuthKey + '/userId/' + this.state.userId)
                .then((Response) => Response.json())
                .then((findresponse) => {
                    this.getErDetails();
                })
        }
    }
    componentDidMount() {
        document.title = this.props.match.params.erId;
        if (!localStorage.getItem('userLogin')) {
            this.setState({ redirect: true });
        }

        this.getErDetails();

        $(document).ready(function () {
            $('.upload_btn label').click(function () {
                $('.upload_btn .inputfile').click();
            });
            $('.inputfile').each(function () {
                var $input = $(this),
                    $label = $input.next('label'),
                    labelVal = $label.html();

                $input.on('change', function (e) {
                    var fileName = '';

                    if (this.files && this.files.length > 1)
                        fileName = (this.getAttribute('data-multiple-caption') || '').replace('{count}', this.files.length);
                    else if (e.target.value)
                        fileName = e.target.value.split('\\').pop();

                    if (fileName)
                        $label.find('span').html(fileName);
                    else
                        $label.html(labelVal);
                });

                // Firefox bug fix
                $input
                    .on('focus', function () { $input.addClass('has-focus'); })
                    .on('blur', function () { $input.removeClass('has-focus'); });
            });

            if (window.File && window.FileList && window.FileReader) {
                $("#files").on("change", function (e) {
                    var files = e.target.files,
                        filesLength = files.length;
                });
            } else {
                alert("Your browser doesn't support to File API")
            }
        });
    }

    maintenance(under_maintenance){
    if(under_maintenance == 1){
    this.setState({ 
        maintenanceWindow: under_maintenance 
    });
    }
    }
    
    render() {
        if (this.state.redirect) {
            return (
                <Redirect to={'/login'} />
            )
        }
        return (
            <div>
                        <MaintenanceWindow receive ={this.maintenance} />
                        {!this.state.maintenanceWindow ?
                                <div>
                <Header brecum_name="Er" brecum_page="Edit Request" />
                <div class="right_col">
                    <span className="error">{this.state.error_message}</span>
                    <div class="loader-new"></div>
                    <div class="intranet_body hidden">
                        <div class="title mob"><HeaderMob page_name="Edit Request" /></div>
                        <div class="form-group">
                        </div>
                        <div class="top-row-form">
                            <div class="form-group">
                                <label for="title">Title<span class="star">*</span></label>
                                <input type="text" name="title" id="title" className="form-control" value={this.state.er.title} onChange={this.onChange.bind(this, 'title')} />
                                <span class="error">{this.state.errors["title"]}</span>
                            </div>
                            <div class="form-group">
                                <label>Descriptions{this.state.er.category == 13 ? '' : <span class="star">*</span>}</label>
                                <textarea class="form-control" name="description" id="description" value={this.state.er.description} onChange={this.onChange.bind(this, 'description')}></textarea>
                                <span class="error">{this.state.errors["description"]}</span>
                            </div>
                        </div>
                        <div class="form-section add row">
                        <div class="form-group col-sm-3 col-xs-6">
                                <label>Reporter<span class="star">*</span></label>
                                <div class="filter">
                                    <select id="reporter" class="form-control" name="user_id" value={this.state.er.user_id} onChange={this.onChange.bind(this, 'user_id')}>
                                        <option value='' selected="selected">Any </option>
                                        {
                                            this.state.owners.map((dynamicData, key) =>
                                                <option value={dynamicData.id}>{dynamicData.name}</option>
                                            )
                                        }
                                    </select>
                                    <i class="fal fa-angle-down" aria-hidden="true"></i>
                                </div>
                                <span class="error">{this.state.errors["user_id"]}</span>
                            </div>
                            {/* Er69532: Edit Category with design Rules, 64 is epic and 10 is new status */}
                            <div class="form-group col-sm-3 col-xs-6">
                                <label>Category<span class="star">*</span></label>
                                <div class="filter">
                                    <select class="form-control" name="category" value={this.state.er.category} onChange={this.onChange.bind(this, 'category')} disabled={(this.state.er.category == 64)||(this.state.er.old_status != 10)?1:0}>
                                        <option value='' selected="selected">Any </option>
                                        {
                                            this.state.category.map((dynamicData, k) =>
                                                <option value={dynamicData.key}>{dynamicData.value}</option>
                                            )
                                        }
                                    </select>
                                    <i class="fal fa-angle-down" aria-hidden="true"></i>
                                </div>
                                <span class="error">{this.state.errors["category"]}</span>
                            </div>
                            <div class="form-group col-sm-3 col-xs-6">
                                <label>Priority<span class="star">*</span></label>
                                <div class="filter">
                                    <select class="form-control" name="priority" value={this.state.er.priority} onChange={this.onChange.bind(this, 'priority')} >
                                        <option value="" selected>Any</option>
                                        {
                                            this.state.priority.map((dynamicData, index) =>
                                                <option value={dynamicData.key}>{dynamicData.value}</option>
                                            )
                                        }
                                    </select>
                                    <i class="fal fa-angle-down" aria-hidden="true"></i>
                                </div>
                                <span class="error">{this.state.errors["priority"]}</span>
                            </div>
												
                            <div class="form-group col-sm-3 col-xs-6">
							    <label>Assigned to{this.state.previous_inserted_er_category == 13 ? '' : <span class="star">*</span>}</label>
                                <div class="filter" name="assign_to_new">
								<MuiThemeProvider muiTheme={getMuiTheme()} class="form-control">
                                    <AutoComplete
									    id="autocomplete"
                                        onUpdateInput={this.handleUpdateInput}
										onNewRequest={ this.onNewRequest.bind(this) }
										onClick={this.handleUpdateInput}
                                        fullWidth={true}
                                        placeholder="Type here to assign"
                                        filter={this.caseInsensitiveFilters}
                                        dataSource={this.state.search}
                                        dataSourceConfig={dataSourceConfig}
                                        errorStyle={{ bottom: 0 }}
                                        errorText={this.state.errorText}
                                        maxSearchResults={500}
                                        className="ticket_search_box"
										searchText={this.state.searchText}
										openOnFocus = {true}
										menuStyle = {{maxHeight: '300px'}}
									 />
                            </MuiThemeProvider>
                                </div>
                                <span class="error">{this.state.errors["assign_to_new"]}</span>
                            </div>
                            {/* ER66478: Efforts are mandatory */}
                            <div class="form-group col-sm-3 col-xs-6">
                                <label>Effort<span class="star">*</span></label>
                                <div class="filter">
                                    <select class="form-control" name="effort" id="effort" value={this.state.er.effort == 0 ? 102 : this.state.er.effort} onChange={this.onChange.bind(this, 'effort')} >
                                        {
                                            this.state.add_sub_effort.map((dynamicData, k) =>
                                                <option value={dynamicData.key}>{dynamicData.value}</option>
                                            )
                                        }
                                    </select>
                                    <i class="fal fa-angle-down" aria-hidden="true"></i>
                                </div>
                                <span class="error">{this.state.errors["effort"]}</span>
                            </div>			
                            <div class="form-group col-sm-3 col-xs-6">
                                <label>Pod/Department{this.state.er.category == 13 ? '' : <span class="star">*</span>}</label>
                                <div class="filter">
                                    <select id="product_id" class="form-control" name="product_line" value={this.state.er.product_line} onChange={this.onChange.bind(this, 'product_line')}>
                                        <option value='' selected="selected">Any </option>
                                        {
                                            this.state.product_line.map((dynamicData, index) =>
                                                <option value={dynamicData.key}>{dynamicData.value}</option>
                                            )
                                        }
                                    </select>
                                    <i class="fal fa-angle-down" aria-hidden="true"></i>
                                </div>
                                <span class="error">{this.state.errors["product_line"]}</span>
                            </div>
                            {/* status is grayed out i.e. disabled as per the discussion with Sailini & Bikash to avoid 'change category & change status at a time' */}
                            <div class="form-group col-sm-3 col-xs-6">
                                <label>Status</label>
                                <div class="filter">
                                    <select class="form-control" name="status" value={this.state.er.status} onChange={this.onChange.bind(this, 'status')} disabled = "true">
                                        {this.state.er.old_status ?
                                            <option value={this.state.er.old_status}>{this.state.config.status[this.state.er.old_status]}</option> : ''}
                                        {
                                            this.state.workflow.map((dynamicData, index) =>
                                                <option value={dynamicData.key}>{dynamicData.value}</option>
                                            )
                                        }
                                    </select>
                                    <i class="fal fa-angle-down" aria-hidden="true"></i>
                                </div>
                            </div>
                            <div class="form-group col-sm-3 col-xs-6">
                                <label>Server</label>
                                <div class="filter">
                                    <select class="form-control" id="server" name="server" value={this.state.er.server} onChange={this.onChange.bind(this, 'server')}>
                                        <option value='' selected > Any</option>
                                        {
                                            this.state.server.map((dynamicData, k) =>
                                                <option value={dynamicData.key}>{dynamicData.value}</option>
                                            )
                                        }
                                    </select>
                                    <i class="fal fa-angle-down" aria-hidden="true"></i>
                                </div>
                            </div>
                            <div class="form-group col-sm-3 col-xs-6">
                                <label>Type<span class="star"></span></label>
                                <div class="filter">
                                    <select class="form-control" name="type" value={this.state.er.type} onChange={this.onChange.bind(this, 'type')}>
                                        {
                                            this.state.type.map((dynamicData, index) =>
                                                <option value={dynamicData.key}>{dynamicData.value}</option>
                                            )
                                        }
                                    </select>
                                    <i class="fal fa-angle-down" aria-hidden="true"></i>
                                </div>
                                <span class="error">{this.state.errors["type"]}</span>
                            </div>
                            <div class="form-group col-sm-3 col-xs-6">
                                <label>Ticket</label>
                                <div class="filter">
                                    <input type="text" name="ticket" className="form-control" value={this.state.er.ticket} onChange={this.onChange.bind(this, 'ticket')} />
                                </div>
                            </div>
                            <div class="form-group col-sm-3 col-xs-6">
                                <label>Escalation Level</label>
                                <div class="filter">
                                    <select class="form-control" name="support_level" id="browser" value={this.state.er.support_level} onChange={this.onChange.bind(this, 'support_level')} >
                                        <option value="" selected="selected">Any</option>
                                        {
                                            this.state.supportLevels.map((dynamicData, index) =>
                                                <option value={dynamicData.escalation_level}>{dynamicData.escalation_level}</option>
                                            )
                                        }
                                    </select>
                                    <i class="fal fa-angle-down" aria-hidden="true"></i>
                                </div>
                            </div>
                            {/* <div class="form-group col-sm-3 col-xs-6 icon-live icon-date">
                                <label>Start Date</label>
                                <div class="filter right">
                                    <DatePicker
                                        selected={this.state.startdate}
                                        onChange={this.startdateChange}
                                        placeholderText="Start Date"
                                        dateFormat="DD/MM/YYYY"
                                        peekNextMonth
                                        showMonthDropdown
                                        showYearDropdown
                                        dropdownMode="select"
                                        minDate={this.state.createddate}
                                        maxDate={this.state.enddate ? this.state.enddate : (this.state.golivedate ? this.state.golivedate : '')}
                                        onBlur={event => this.focousOutStartDate(event.target.value)}
                                        isClearable={true}
                                    />
                                </div>
                            </div>
                            <div class="form-group col-sm-3 col-xs-6 icon-live icon-date">
                                <label>End Date</label>
                                <div class="filter right">
                                    <DatePicker
                                        selected={this.state.enddate}
                                        onChange={this.enddateChange}
                                        placeholderText="End Date"
                                        dateFormat="DD/MM/YYYY"
                                        peekNextMonth
                                        showMonthDropdown
                                        showYearDropdown
                                        dropdownMode="select"
                                        minDate={this.state.startdate ? this.state.startdate : (this.state.createddate ? this.state.createddate : '')}
                                        maxDate={this.state.golivedate}
                                        onBlur={event => this.focousOutEndDate(event.target.value)}
                                        isClearable={true}
                                    />
                                </div>

                            </div>
                            <div class="form-group col-sm-3 col-xs-6 icon-live icon-date">
                                <label>Go-live Date</label>
                                <div class="filter right">
                                    <DatePicker
                                        selected={this.state.golivedate}
                                        onChange={this.golivedateChange}
                                        placeholderText="Go Live Date"
                                        dateFormat="DD/MM/YYYY"
                                        peekNextMonth
                                        showMonthDropdown
                                        showYearDropdown
                                        dropdownMode="select"
                                        minDate={this.state.enddate ? this.state.enddate : (this.state.startdate ? this.state.startdate : (this.state.createddate ? this.state.createddate : ''))}
                                        onBlur={event => this.focousOutGoLiveDate(event.target.value)}
                                        isClearable={true}
                                    />
                                </div>
                            </div> */}
                            <div class="form-group col-sm-3 col-xs-6">
                                <label>Os Version</label>
                                <div class="filter">
                                    <select class="form-control" name="os_version" id="os_version" value={this.state.er.os_version} onChange={this.onChange.bind(this, 'os_version')} >
                                        <option value="" selected="selected">Any</option>
                                        {
                                            this.state.os_version.map((dynamicData, index) =>
                                                <option value={dynamicData.key}>{dynamicData.value}</option>
                                            )
                                        }
                                    </select>
                                    <i class="fal fa-angle-down" aria-hidden="true"></i>
                                </div>
                            </div>
                            <div class="form-group col-sm-3 col-xs-6">
                                <label>Browser</label>
                                <div class="filter">
                                    <select class="form-control" name="browser" id="browser" value={this.state.er.browser} onChange={this.onChange.bind(this, 'browser')} >
                                        <option value="" selected="selected">Any</option>
                                        {
                                            this.state.browser.map((dynamicData, index) =>
                                                <option value={dynamicData.key}>{dynamicData.value}</option>
                                            )
                                        }
                                    </select>
                                    <i class="fal fa-angle-down" aria-hidden="true"></i>
                                </div>
                            </div>
                            <div class="form-group col-sm-3 col-xs-6">
                                <label>Browser Version</label>
                                <div class="filter">
                                    <input type="text" name="browser_version" className="form-control" value={this.state.er.browser_version} onChange={this.onChange.bind(this, 'browser_version')} />
                                    <span className="error">{this.state.errors["browser_version"]}</span>
                                </div>
                            </div>
                            {/* <div class="form-group col-sm-3 col-xs-6">
                                <label>Microservice</label>
                                <div class="filter">
                                    <select class="form-control" name="microservice" id="microservice" value={this.state.er.microservice} onChange={this.onChange.bind(this, 'microservice')} >
                                        {
                                            this.state.microservice.map((dynamicData, index) =>
                                                <option value={dynamicData.key}>{dynamicData.value}</option>
                                            )
                                        }
                                    </select>
                                    <i class="fal fa-angle-down" aria-hidden="true"></i>
                        </div>
                            </div> */}
                            <div class="col-sm-12 col-xs-6">
                                {this.state.er.category == 12 && (this.state.er.product_line == 4 || this.state.er.product_line == 14 || this.state.er.product_line == 25) ?
                                    <div>
                                    <p class="feature-check box">
                                            <input type="checkbox" name="feature_type" class="feature_type" id="platform_feature" value="3" defaultChecked={this.state.platform_feature_checked} onClick={this.onFeatureChange.bind(this, '#platform_feature')} />
                                    <label for="platform_feature"><span></span>{'Platform'}</label>
                                </p>
                                <p class="feature-check box">
                                            <input type="checkbox" name="feature_type" class="feature_type" id="native_feature" value="2" defaultChecked={this.state.native_feature_checked} onClick={this.onFeatureChange.bind(this, '#native_feature')} />
                                            <label for="native_feature"><span></span>{'Native(Mobile/TV)'}</label>
                                </p>
                                    </div>
                                    : (this.state.er.category == 12 && (this.state.er.product_line != 4 && this.state.er.product_line != 14 && this.state.er.product_line != 25) ?
                                        <p class="feature-check box">
                                            <input type="checkbox" name="feature_type" class="feature_type" id="major_feature" value="1" defaultChecked={this.state.major_feature_checked} onClick={this.onFeatureChange.bind(this, '#major_feature')} />
                                    <label for="major_feature"><span></span>{'Major Feature'}</label>
                                </p> : '')}
                        </div>
                        </div>
                        <div class="upload show_upload">
                            <h4 class="pull-left border-bottom"></h4>
                            {
                                this.state.er_attachment.map((data, key) =>
                                    <div class="attached attach_delete">
                                        <span onClick={() => this.showImage(data.url)}  >
                                            <i class="far fa-file"></i>{data.attachment_name}
                                        </span>
                                        <span class="delete" onClick={() => this.delteimage(data.id, data.entity_id)}  >
                                            <i class="fa fa-trash"></i>
                                        </span>
                                    </div>
                                )}
                        </div>
                        <div class="upload">
                            <label>Add Attachment :</label>
                            <div class="upload_btn">
                                <input type="file" name="attachments" id="attachments" class="inputfile inputfile-1" data-multiple-caption="{count} files selected" multiple />
                                <label for="file-1">
                                    <i class="fa fa-plus hidden-sm" aria-hidden="true"></i>
                                    <span>Choose file</span>
                                    <i class="fa fa-cloud-upload-alt hidden-md" aria-hidden="true"></i>
                                </label>
                            </div>
                        </div>
                        <button type="submit" name="add_request" id="add_request" class="btn btn-sky mob-btn" onClick={() => this.updateEr()}>Submit</button>
                        <Link to={`/viewEr/${this.state.er.id}`} name={"max"}><button className="btn btn-blue hidden-sm">Back</button></Link>
                    </div>
                </div>
            </div>
            :
                 <div></div>        
                        }
            </div>
        )
    }
}

export default UpdateEr;


// WEBPACK FOOTER //
// ./src/components/er/updateEr.js